import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {noop} from 'lodash';
import {actionIcInfo24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {isValidFunction, labels} from '../../../../util/utils';
import {clientSideEventNames} from '../../../../util/uiconstants';
import IconButton from '../../BaseComponentWrappers/MotifIconButton';

function ToggleGuidanceButton({label, value, onValueChange, className, motifIconSrc, tooltip}) {
	const handleOnClick = (e) => {
		e.stopPropagation();

		const newValue = !value;
		if (newValue === true && isValidFunction(onValueChange)) {
			onValueChange(newValue);
		}
	};

	useEffect(() => {
		window.addEventListener(clientSideEventNames.closeTypeEightGuidanceModal, () => {
			isValidFunction(onValueChange) ? onValueChange(false) : null;
		});
		return () => {
			window.removeEventListener(clientSideEventNames.closeTypeEightGuidanceModal, () => {
				isValidFunction(onValueChange) ? onValueChange(false) : null;
			});
		};
	}, []);

	const haveTooltip = typeof tooltip === 'string' && tooltip.length > 0;

	const buttonRender = (
		<StyledMotifIconButton
			className={`StyledMotifIconButton ${className} ${value ? 'activated' : 'deactivated'}`}
			aria-label={label}
			type="button"
			onClick={handleOnClick}
			iconSource={motifIconSrc}
			iconTitle={labels.guidance}
		/>
	);

	if (haveTooltip) {
		return (
			<StyledToggleGuidanceButton className={`StyledToggleGuidanceButton ${value ? 'activated' : 'deactivated'}`}>
				{buttonRender}
			</StyledToggleGuidanceButton>
		);
	}

	return buttonRender;
}

ToggleGuidanceButton.propTypes = {
	label: PropTypes.string,
	value: PropTypes.bool,
	onValueChange: PropTypes.func,
	className: PropTypes.string,
	motifIconSrc: PropTypes.string,
	tooltip: PropTypes.string
};

ToggleGuidanceButton.defaultProps = {
	label: labels.guidance,
	value: false,
	onValueChange: noop,
	className: 'toggle-guidance-button',
	motifIconSrc: actionIcInfo24px,
	tooltip: labels.guidance
};

export default ToggleGuidanceButton;

const StyledToggleGuidanceButton = styled.section`
	display: flex;
	align-items: center;
	justify-content: center;
	height: var(--px-32);
	width: var(--px-60);
	padding: 0 var(--px-10);
	margin: 0;
	position: relative;
	&:hover,
	&:focus,
	&.activated {
		color: var(--neutrals-00white) !important;
		background-color: var(--neutrals-900) !important;
		border-radius: var(--px-20);
		cursor: pointer;
		svg {
			width: var(--px-20) !important;
			height: var(--px-20) !important;
			fill: var(--neutrals-00white) !important;
			/* fill: var(--brand-500) !important; */
			path {
				fill: var(--neutrals-00white) !important;
				/* fill: var(--brand-500) !important; */
			}
		}
	}
	.motif-button {
		.motif-icon {
			svg {
				width: var(--px-16) !important;
				height: var(--px-16) !important;
			}
		}
	}
	.motif-button-ghost {
		&.motif-active,
		&:hover:not(:disabled) {
			background: transparent !important;
		}
	}
`;

const StyledMotifIconButton = styled(IconButton)`
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	width: var(--px-30) !important;
	padding: var(--px-5);
	border: var(--px-1) solid var(--neutrals-00white);
	background-color: var(--neutrals-00white);
	border-radius: var(--px-5);
`;
